var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWhatsAppEnableIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.1488 11.0522C11.8081 11.1914 11.5905 11.7248 11.3697 11.9972C11.2565 12.1368 11.1215 12.1586 10.9475 12.0886C9.66888 11.5792 8.68872 10.726 7.98314 9.5493C7.86361 9.36683 7.88506 9.2227 8.0292 9.05324C8.24224 8.80223 8.51013 8.51711 8.56779 8.17891C8.69576 7.43078 7.71771 5.11012 6.42608 6.16164C2.70938 9.19035 12.6262 17.2232 14.416 12.8786C14.9222 11.6471 12.7134 10.8209 12.1488 11.0522ZM10 17.4278C8.68556 17.4278 7.39217 17.0784 6.25979 16.4167C6.07804 16.3102 5.85831 16.2821 5.65511 16.3373L3.19454 17.0126L4.05164 15.1244C4.16836 14.8674 4.13848 14.5682 3.97359 14.3397C3.05672 13.0688 2.57192 11.5683 2.57192 10C2.57192 5.90395 5.90401 2.57184 10 2.57184C14.0961 2.57184 17.4278 5.90395 17.4278 10C17.4278 14.0957 14.0957 17.4278 10 17.4278ZM10 1C5.03742 1 1.00009 5.03734 1.00009 10C1.00009 11.7459 1.49579 13.4225 2.43763 14.8776L1.07041 17.8887C0.944196 18.1668 0.99025 18.4923 1.18783 18.724C1.3397 18.9016 1.55943 19 1.78618 19C2.29313 19 5.05746 18.1313 5.76093 17.9383C7.06135 18.634 8.51998 19 10 19C14.9623 19 19 14.9623 19 10C19 5.03734 14.9623 1 10 1Z",
    fill: "#39AE41"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhatsAppEnableIcon);
export default __webpack_public_path__ + "static/media/WhatsAppEnableIcon.7eea6c8f9e8d2806c78f590e0b4a22df.svg";
export { ForwardRef as ReactComponent };